import(/* webpackMode: "eager" */ "/home/ubuntu/download_production/69f4770f63911b0014e68204/asharecovery/src/app/about/page.tsx");
